import PropTypes from 'prop-types';

const recentServiceShape = PropTypes.shape({
  isRegistered: PropTypes.func,
  register: PropTypes.func,
  getRecentActivityList: PropTypes.func,
});

export default recentServiceShape;
